var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStariconPOs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 0L9.16466 2.96555C9.70072 5.35734 11.5367 7.24419 13.9129 7.84543L16.5 8.5L13.9129 9.15457C11.5367 9.75581 9.70072 11.6427 9.16466 14.0344L8.5 17L7.83534 14.0344C7.29928 11.6427 5.46331 9.75581 3.08707 9.15457L0.5 8.5L3.08707 7.84543C5.46331 7.24419 7.29928 5.35735 7.83534 2.96555L8.5 0Z",
    fill: "#FD830C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStariconPOs);
export default __webpack_public_path__ + "static/media/StariconPOs.d95b6ba2164fc9833ea0994fa811a8ab.svg";
export { ForwardRef as ReactComponent };